import { useState } from 'react';

import { usePalletsTypes } from 'constants/palletTypes';
import { PalletAmountDTO, PalletBalance, PalletReportDTO } from 'interfaces';
import {
   getDamagedPalletsFromReports,
   getDefaultPalletsBalanceValues,
   sumPalletsBalances,
} from 'utils/functions';

export const useClientPalletsBalance = () => {
   const { PALLET_TYPES } = usePalletsTypes();

   const [rentedPallets, setRentedPallets] = useState<PalletBalance>(
      getDefaultPalletsBalanceValues(),
   );
   const [damagedByClientPallets, setDamagedByClientPallets] = useState<PalletBalance>(
      getDefaultPalletsBalanceValues(),
   );
   const [lostOrDestroyedByClientPallets, setLostOrDestroyedByClientPallets] =
      useState<PalletBalance>(getDefaultPalletsBalanceValues());
   const [damagedOrLostBySupplierPallets, setDamagedOrLostBySupplierPallets] =
      useState<PalletBalance>(getDefaultPalletsBalanceValues());
   const [remainingPallets, setRemainingPallets] = useState<PalletAmountDTO[]>([]);

   const handleLostDamagedBySupplierPalletReports = (reports: PalletReportDTO[]) => {
      const receivedDamagedPalletsFromReports = getDamagedPalletsFromReports(reports, PALLET_TYPES);
      setDamagedOrLostBySupplierPallets(prevPalletsData => {
         return sumPalletsBalances(
            prevPalletsData,
            receivedDamagedPalletsFromReports,
            PALLET_TYPES,
         );
      });
   };

   const handleLostByClientPalletReports = (reports: PalletReportDTO[]) => {
      const lostOrDestroyedByUserFaultPalletsFromReports = getDamagedPalletsFromReports(
         reports,
         PALLET_TYPES,
         'LOST_OR_DESTRUCTION',
      );
      setLostOrDestroyedByClientPallets(prevPalletsData => {
         return sumPalletsBalances(
            prevPalletsData,
            lostOrDestroyedByUserFaultPalletsFromReports,
            PALLET_TYPES,
         );
      });
   };

   const handleDamagedByClientPalletReports = (reports: PalletReportDTO[]) => {
      const damagedByUserFaultPalletsFromReports = getDamagedPalletsFromReports(
         reports,
         PALLET_TYPES,
         'DAMAGE',
      );
      setDamagedByClientPallets(prevPalletsData => {
         return sumPalletsBalances(
            prevPalletsData,
            damagedByUserFaultPalletsFromReports,
            PALLET_TYPES,
         );
      });
   };

   return {
      rentedPallets,
      damagedByClientPallets,
      lostOrDestroyedByClientPallets,
      damagedOrLostBySupplierPallets,
      remainingPallets,
      setRentedPallets,
      setDamagedByClientPallets,
      setLostOrDestroyedByClientPallets,
      setDamagedOrLostBySupplierPallets,
      setRemainingPallets,
      handleLostDamagedBySupplierPalletReports,
      handleLostByClientPalletReports,
      handleDamagedByClientPalletReports,
   };
};
